import {DashboardSearchEntity} from 'copilot/indexer/dashboards';
import type {EventSearchEntity} from 'copilot/indexer/events';
import type {MetricSearchEntity} from 'copilot/indexer/metrics';
import type {ReportSearchEntity} from 'copilot/indexer/reports';
import type {SearchEntityResponse} from 'copilot/indexer/types';

type EventSearchEntityHit = SearchEntityResponse<EventSearchEntity>;
type MetricSearchEntityHit = SearchEntityResponse<MetricSearchEntity>;
type ReportSearchEntityHit = SearchEntityResponse<ReportSearchEntity>;
type DashboardSearchEntityHit = SearchEntityResponse<DashboardSearchEntity>;

export type SearchQuestionHitType =
  | EventSearchEntityHit
  | MetricSearchEntityHit
  | ReportSearchEntityHit
  | DashboardSearchEntityHit;

export function isEventHit(hit: SearchQuestionHitType): hit is EventSearchEntity {
  return hit.collection === `events`;
}

export function isMetricHit(hit: SearchQuestionHitType): hit is MetricSearchEntity {
  return hit.collection === `metrics`;
}

export function isReportHit(hit: SearchQuestionHitType): hit is ReportSearchEntity {
  return hit.collection === `reports`;
}

export function isDashboardHit(hit: SearchQuestionHitType): hit is DashboardSearchEntityHit {
  return hit.collection === `dashboards`;
}
